import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "./Css/View.css";
import profile from "./Images/Ellipse 24 (4).png";
import API_BASE from "../config/api";

const InstitudeSoftEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [imagePreview, setImagePreview] = useState(profile);

  const [formData, setFormData] = useState({
    instituteName: "",
    softwareName: "",
    profilePictureUrl: "",
    subscriptionType: "",
    softwarePrice: "",
    duration: "",
    startDate: "",
    softwareEndDate: "",
    renewalDate: "",
    isActive: true,
    status: 0,

    // frontend-only fields (hardcoded for now)
    paymentStatus: "पेमेंट झाले आहे",
    studentLimit: "",
  });

  // ================= FETCH DATA =================
  useEffect(() => {
    fetchSoftwareDetails();
  }, []);

  const fetchSoftwareDetails = async () => {
    try {
      const res = await axios.get(
        `${API_BASE}/api/Institutes/software/${id}`
      );

      const data = res.data;

      setFormData({
        instituteName: data.instituteName,
        softwareName: data.softwareName,
        profilePictureUrl: data.profilePictureUrl,
        subscriptionType: getSubscriptionValue(data.subscriptionType),
        softwarePrice: data.softwarePrice,
        duration: getDurationValue(data.duration),
        startDate: data.purchaseDate?.split("T")[0],
        endDate: data.softwareEndDate?.split("T")[0],
        renewalDate: data.renewalDate?.split("T")[0],
        isActive: data.status === 1,
        status: data.status,
        paymentStatus: "पेमेंट झाले आहे",
        studentLimit: data.studentCapacity,
      });

      if (data.profilePictureUrl) {
        setImagePreview(data.profilePictureUrl);
      }

      setLoading(false);
      console.log(res.data, 'data')
    } catch (error) {
      console.error("Error fetching software:", error);
    }
  };

  // ================= ENUM HELPERS =================
  const getSubscriptionValue = (value) => {
    if (value === "बेसिक") return 1;
    if (value === "स्टॅंडर्ड") return 2;
    if (value === "प्रीमियम") return 3;
    return 0;
  };

  const getDurationValue = (value) => {
    if (value === "मासिक") return 1;
    if (value === "वार्षिक") return 2;
    return ;
  };

  // ================= INPUT CHANGE =================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // ================= IMAGE CHANGE =================
  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setImagePreview(previewUrl);

      // For now just storing preview URL
      setFormData({
        ...formData,
        profilePictureUrl: previewUrl,
      });
    }
  };

  // ================= UPDATE =================
  const handleSave = async () => {
    try {
      await axios.put(
        `${API_BASE}/api/Institutes/software/${id}`,
        {
          subscriptionType: parseInt(formData.subscriptionType),
          softwarePrice: parseFloat(formData.softwarePrice),
          duration: parseInt(formData.duration),
          startDate: new Date(formData.startDate).toISOString(),
          isActive: formData.isActive,
          profilePictureUrl: formData.profilePictureUrl,
          status: formData.status,
        }
      );

      alert("Software updated successfully");
      navigate(-1);
    } catch (error) {
      console.error("Update error:", error);
      alert("Error updating software");
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="student-page">
      {/* Header */}
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          संस्था व्यवस्थापन &gt;&gt; तपशील&gt;&gt; सॉफ्टवेअर माहिती&gt;&gt;{" "}
          <span>सॉफ्टवेअर संपादन</span>
        </h3>

        <div className="edit-btnn">
          <button className="btn outlinee" onClick={() => navigate(-1)}>
            रद्द करा
          </button>
          <button className="btn primaryy" onClick={handleSave}>
            सेव्ह करा
          </button>
        </div>
      </div>

      <p>
        संस्थेचे नाव: <strong>{formData.instituteName}</strong>
      </p>

      <h2>सॉफ्टवेअर संपादन </h2>

      {/* Profile Section */}
      <div className="profile-card">
        <div className="profile-img-wrapper">
          <img
            src={imagePreview || profile}
            alt="software"
            className="profile-img"
          />

          <label className="edit-icon">
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              hidden
            />
          </label>
        </div>

        <p>{formData.softwareName}</p>
      </div>

      {/* Editable Grid */}
      <div className="info-gridd">
        <div className="info-boxx">
          <label>सॉफ्टवेअर पॅकेज</label>
          <select
            name="subscriptionType"
            value={formData.subscriptionType}
            onChange={handleChange}
          >
            <option value={1}>बेसिक</option>
            <option value={2}>स्टॅंडर्ड</option>
            <option value={3}>प्रीमियम</option>
          </select>
        </div>

        <div className="info-boxx">
          <label>खरेदी दिनांक</label>
          <input
            type="date"
            name="startDate"
            value={formData.startDate}
            onChange={handleChange}
          />
        </div>

        <div className="info-boxx">
          <label>सॉफ्टवेअर पॅकेज नाव</label>
          <input
            type="text"
            name="softwareName"
            value={formData.softwareName}
            onChange={handleChange}
          />
        </div>

        <div className="info-boxx">
          <label>किंमत</label>
          <input
            type="number"
            name="softwarePrice"
            value={formData.softwarePrice}
            onChange={handleChange}
          />
        </div>

        <div className="info-boxx">
          <label>पेमेंट स्टेटस</label>
          <input
            type="text"
            name="paymentStatus"
            value={formData.paymentStatus}
            onChange={handleChange}
          />
        </div>

        <div className="info-boxx">
          <label>कालावधी</label>
          <select
            name="duration"
            value={formData.duration}
            onChange={handleChange}
          >
            <option value={1}>मासिक</option>
            <option value={2}>वार्षिक</option>
          </select>
        </div>

        <div className="info-boxx">
          <label>स्टुडंट लिमिट</label>
          <input
            type="text"
            name="studentLimit"
            value={formData.studentLimit}
            onChange={handleChange}
          />
        </div>

        <div className="info-boxx">
          <label>समाप्ती तारीख</label>
          <input type="text" value={formData.endDate} disabled />
        </div>

        <div className="info-boxx">
          <label>नूतनीकरण तारीख</label>
          <input type="text" value={formData.renewalDate} disabled />
        </div>
      </div>
    </div>
  );
};

export default InstitudeSoftEdit;
